/**
 * GiftCardsEmptyState — no-results copy for the list (BON-223). Quotes the
 * search term when one was typed, else names the filters, else reads as a
 * true empty state — see `giftCardEmptyCopy`.
 */
import { giftCardEmptyCopy } from './giftCardsModel';

export function GiftCardsEmptyState({ search, filtered }: { search: string; filtered: boolean }) {
  const copy = giftCardEmptyCopy(search, filtered);
  return (
    <div style={{ padding: '46px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--nb-muted)', marginBottom: 4 }}>
        {copy.title}
      </div>
      <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>{copy.body}</div>
    </div>
  );
}
